export const REGEX_PATTERN_NUMBER_OR_STRING =
  /(^[a-z]{2}[0-9]{3}$)|(^[0-9]{4,6}$)/;
export const REGEX_PATTERN_NUMBER = '^[0-9]{8}$';
export const KEYWORDS_REGEX = '^[^,]+(,[^,]+)*$';
